import { css } from 'styled-components';
import { icons } from './icons';

interface IImageIcon {
  icon: string;
  width?: number;
  height?: number;
  color?: string;
  left?: number;
  top?: number;
}

export const getIcon = (icon: string) => icons[icon];

export const imageIcon = ({ icon, width = 20, height = 20, color = 'black', left = 0, top = 0 }: IImageIcon) => css`
  display: inline-block;
  width: ${width}px;
  height: ${height}px;
  content: '';
  color: ${color};
  background-repeat: no-repeat;
  background-position: ${left}px ${top}px;
  background-size: ${width}px ${height}px;
  background-image: url(${getIcon(icon)});
`;

